import { TabPill } from 'types/tabs';

const ExpenseTrackerConstants = {};

export enum ExpenseStatus {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

const rejectReasons = [
  {
    id: 'not_valid',
    label: 'Not valid',
    value: 'not_valid'
  },
  {
    id: 'duplicate',
    label: 'Duplicate',
    value: 'duplicate'
  },
  {
    id: 'other',
    label: 'Other',
    value: 'other'
  }
];

const expenseTrackerColumns = [
  {
    Header: 'Title',
    accessor: 'title'
  },
  {
    Header: 'Category',
    accessor: 'categoryName'
  },
  {
    Header: 'Branch',
    accessor: 'branchName'
  },
  {
    Header: 'Amount',
    accessor: 'formattedAmount'
  },
  {
    Header: 'Expense Date',
    accessor: 'expenseDate'
  },
  {
    Header: 'Action',
    accessor: 'action'
  }
];

const expenseTabs: TabPill[] = [
  { id: ExpenseStatus.APPROVED, label: 'Approved' },
  { id: ExpenseStatus.PENDING, label: 'Pending' },
  { id: ExpenseStatus.REJECTED, label: 'Rejected' }
];

export {
  expenseTabs,
  expenseTrackerColumns,
  ExpenseTrackerConstants,
  rejectReasons
};
